// 本地开发用 localhost；打包部署用服务器 IP（与数据库连接无关）
// 端口约定：官网后端 8838 | 前端开发 8840 | ERP 占用 8088
export const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? 'http://106.55.198.60:8838'
  : 'http://localhost:8838'